'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IntegrationManagers = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _bluebird = require('bluebird');

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _SdkConfig = require('../SdkConfig');

var _SdkConfig2 = _interopRequireDefault(_SdkConfig);

var _index = require('../index');

var _index2 = _interopRequireDefault(_index);

var _Modal = require('../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _IntegrationManagerInstance = require('./IntegrationManagerInstance');

var _WidgetUtils = require('../utils/WidgetUtils');

var _WidgetUtils2 = _interopRequireDefault(_WidgetUtils);

var _MatrixClientPeg = require('../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _matrixJsSdk = require('matrix-js-sdk');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HS_MANAGERS_REFRESH_INTERVAL = 8 * 60 * 60 * 1000; // 8 hours
/*
Copyright 2019 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var KIND_PREFERENCE = [
// Ordered: first is most preferred, last is least preferred.
_IntegrationManagerInstance.KIND_ACCOUNT, _IntegrationManagerInstance.KIND_HOMESERVER, _IntegrationManagerInstance.KIND_CONFIG];

var IntegrationManagers = exports.IntegrationManagers = function () {
    (0, _createClass3.default)(IntegrationManagers, null, [{
        key: 'sharedInstance',
        value: function sharedInstance() {
            if (!IntegrationManagers._instance) {
                IntegrationManagers._instance = new IntegrationManagers();
            }
            return IntegrationManagers._instance;
        }
    }]);

    function IntegrationManagers() {
        (0, _classCallCheck3.default)(this, IntegrationManagers);
        this._managers = [];
        this._wellknownRefreshTimerId = null;

        this._compileManagers();
    }

    (0, _createClass3.default)(IntegrationManagers, [{
        key: 'startWatching',
        value: function startWatching() {
            var _this = this;

            this.stopWatching();
            this._client = _MatrixClientPeg2.default.get();
            this._client.on("accountData", this._onAccountData.bind(this));
            this._compileManagers();
            setInterval(function () {
                return _this._setupHomeserverManagers();
            }, HS_MANAGERS_REFRESH_INTERVAL);
        }
    }, {
        key: 'stopWatching',
        value: function stopWatching() {
            if (!this._client) return;
            this._client.removeListener("accountData", this._onAccountData.bind(this));
            if (this._wellknownRefreshTimerId !== null) clearInterval(this._wellknownRefreshTimerId);
        }
    }, {
        key: '_compileManagers',
        value: function _compileManagers() {
            this._managers = [];
            this._setupConfiguredManager();
            this._setupHomeserverManagers();
            this._setupAccountManagers();
        }
    }, {
        key: '_setupConfiguredManager',
        value: function _setupConfiguredManager() {
            var apiUrl = _SdkConfig2.default.get()['integrations_rest_url'];
            var uiUrl = _SdkConfig2.default.get()['integrations_ui_url'];

            if (apiUrl && uiUrl) {
                this._managers.push(new _IntegrationManagerInstance.IntegrationManagerInstance(_IntegrationManagerInstance.KIND_CONFIG, apiUrl, uiUrl));
                this._primaryManager = null; // reset primary
            }
        }
    }, {
        key: '_setupHomeserverManagers',
        value: function () {
            var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var homeserverDomain, discoveryResponse, managers, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, hsManager;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;

                                console.log("Updating homeserver-configured integration managers...");
                                homeserverDomain = _MatrixClientPeg2.default.getHomeserverName();
                                _context.next = 5;
                                return (0, _bluebird.resolve)(_matrixJsSdk.AutoDiscovery.getRawClientConfig(homeserverDomain));

                            case 5:
                                discoveryResponse = _context.sent;

                                if (!(discoveryResponse && discoveryResponse['m.integrations'])) {
                                    _context.next = 41;
                                    break;
                                }

                                managers = discoveryResponse['m.integrations']['managers'];

                                if (!Array.isArray(managers)) managers = []; // make it an array so we can wipe the HS managers

                                console.log('Homeserver has ' + managers.length + ' integration managers');

                                // Clear out any known managers for the homeserver
                                // TODO: Log out of the scalar clients
                                this._managers = this._managers.filter(function (m) {
                                    return m.kind !== _IntegrationManagerInstance.KIND_HOMESERVER;
                                });

                                // Now add all the managers the homeserver wants us to have
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context.prev = 14;
                                _iterator = (0, _getIterator3.default)(managers);

                            case 16:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _context.next = 24;
                                    break;
                                }

                                hsManager = _step.value;

                                if (hsManager["api_url"]) {
                                    _context.next = 20;
                                    break;
                                }

                                return _context.abrupt('continue', 21);

                            case 20:
                                this._managers.push(new _IntegrationManagerInstance.IntegrationManagerInstance(_IntegrationManagerInstance.KIND_HOMESERVER, hsManager["api_url"], hsManager["ui_url"]) // optional
                                );

                            case 21:
                                _iteratorNormalCompletion = true;
                                _context.next = 16;
                                break;

                            case 24:
                                _context.next = 30;
                                break;

                            case 26:
                                _context.prev = 26;
                                _context.t0 = _context['catch'](14);
                                _didIteratorError = true;
                                _iteratorError = _context.t0;

                            case 30:
                                _context.prev = 30;
                                _context.prev = 31;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 33:
                                _context.prev = 33;

                                if (!_didIteratorError) {
                                    _context.next = 36;
                                    break;
                                }

                                throw _iteratorError;

                            case 36:
                                return _context.finish(33);

                            case 37:
                                return _context.finish(30);

                            case 38:

                                this._primaryManager = null; // reset primary
                                _context.next = 42;
                                break;

                            case 41:
                                console.log("Homeserver has no integration managers");

                            case 42:
                                _context.next = 47;
                                break;

                            case 44:
                                _context.prev = 44;
                                _context.t1 = _context['catch'](0);

                                console.error(_context.t1);
                                // Errors during discovery are non-fatal

                            case 47:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 44], [14, 26, 30, 38], [31,, 33, 37]]);
            }));

            function _setupHomeserverManagers() {
                return _ref.apply(this, arguments);
            }

            return _setupHomeserverManagers;
        }()
    }, {
        key: '_setupAccountManagers',
        value: function _setupAccountManagers() {
            var _this2 = this;

            if (!this._client || !this._client.getUserId()) return; // not logged in
            var widgets = _WidgetUtils2.default.getIntegrationManagerWidgets();
            widgets.forEach(function (w) {
                var data = w.content['data'];
                if (!data) return;

                var uiUrl = w.content['url'];
                var apiUrl = data['api_url'];
                if (!apiUrl || !uiUrl) return;

                var manager = new _IntegrationManagerInstance.IntegrationManagerInstance(_IntegrationManagerInstance.KIND_ACCOUNT, apiUrl, uiUrl);
                manager.id = w['id'] || w['state_key'] || '';
                _this2._managers.push(manager);
            });
            this._primaryManager = null; // reset primary
        }
    }, {
        key: '_onAccountData',
        value: function _onAccountData(ev) {
            if (ev.getType() === 'm.widgets') {
                this._compileManagers();
            }
        }
    }, {
        key: 'hasManager',
        value: function hasManager() {
            return this._managers.length > 0;
        }
    }, {
        key: 'getOrderedManagers',
        value: function getOrderedManagers() {
            var _this3 = this;

            var ordered = [];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                var _loop = function _loop() {
                    var kind = _step2.value;

                    var managers = _this3._managers.filter(function (m) {
                        return m.kind === kind;
                    });
                    if (!managers || !managers.length) return 'continue';

                    if (kind === _IntegrationManagerInstance.KIND_ACCOUNT) {
                        // Order by state_keys (IDs)
                        managers.sort(function (a, b) {
                            return a.id.localeCompare(b.id);
                        });
                    }

                    ordered.push.apply(ordered, (0, _toConsumableArray3.default)(managers));
                };

                for (var _iterator2 = (0, _getIterator3.default)(KIND_PREFERENCE), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _ret = _loop();

                    if (_ret === 'continue') continue;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return ordered;
        }
    }, {
        key: 'getPrimaryManager',
        value: function getPrimaryManager() {
            if (this.hasManager()) {
                if (this._primaryManager) return this._primaryManager;

                this._primaryManager = this.getOrderedManagers()[0];
                return this._primaryManager;
            } else {
                return null;
            }
        }
    }, {
        key: 'openNoManagerDialog',
        value: function openNoManagerDialog() {
            // TODO: Is it Integrations (plural) or Integration (singular). Singular is easier spoken.
            var IntegrationsManager = _index2.default.getComponent("views.settings.IntegrationsManager");
            _Modal2.default.createTrackedDialog("Integration Manager", "None", IntegrationsManager, { configured: false }, 'mx_IntegrationsManager');
        }
    }, {
        key: 'openAll',
        value: function openAll() {
            var room = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var screen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var integrationId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            var TabbedIntegrationManagerDialog = _index2.default.getComponent("views.dialogs.TabbedIntegrationManagerDialog");
            _Modal2.default.createTrackedDialog('Tabbed Integration Manager', '', TabbedIntegrationManagerDialog, { room: room, screen: screen, integrationId: integrationId }, 'mx_TabbedIntegrationManagerDialog');
        }
    }, {
        key: 'overwriteManagerOnAccount',
        value: function () {
            var _ref2 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(manager) {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return (0, _bluebird.resolve)(_WidgetUtils2.default.removeIntegrationManagerWidgets());

                            case 2:
                                _context2.next = 4;
                                return (0, _bluebird.resolve)(_WidgetUtils2.default.addIntegrationManagerWidget(manager.name, manager.uiUrl, manager.apiUrl));

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function overwriteManagerOnAccount(_x4) {
                return _ref2.apply(this, arguments);
            }

            return overwriteManagerOnAccount;
        }()

        /**
         * Attempts to discover an integration manager using only its name. This will not validate that
         * the integration manager is functional - that is the caller's responsibility.
         * @param {string} domainName The domain name to look up.
         * @returns {Promise<IntegrationManagerInstance>} Resolves to an integration manager instance,
         * or null if none was found.
         */

    }, {
        key: 'tryDiscoverManager',
        value: function () {
            var _ref3 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(domainName) {
                var url, wkConfig, result, widget, manager;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                console.log("Looking up integration manager via .well-known");
                                if (domainName.startsWith("http:") || domainName.startsWith("https:")) {
                                    // trim off the scheme and just use the domain
                                    url = url.parse(domainName);

                                    domainName = url.host;
                                }

                                wkConfig = void 0;
                                _context3.prev = 3;
                                _context3.next = 6;
                                return (0, _bluebird.resolve)(fetch('https://' + domainName + '/.well-known/matrix/integrations'));

                            case 6:
                                result = _context3.sent;
                                _context3.next = 9;
                                return (0, _bluebird.resolve)(result.json());

                            case 9:
                                wkConfig = _context3.sent;
                                _context3.next = 17;
                                break;

                            case 12:
                                _context3.prev = 12;
                                _context3.t0 = _context3['catch'](3);

                                console.error(_context3.t0);
                                console.warn("Failed to locate integration manager");
                                return _context3.abrupt('return', null);

                            case 17:
                                if (!(!wkConfig || !wkConfig["m.integrations_widget"])) {
                                    _context3.next = 20;
                                    break;
                                }

                                console.warn("Missing integrations widget on .well-known response");
                                return _context3.abrupt('return', null);

                            case 20:
                                widget = wkConfig["m.integrations_widget"];

                                if (!(!widget["url"] || !widget["data"] || !widget["data"]["api_url"])) {
                                    _context3.next = 24;
                                    break;
                                }

                                console.warn("Malformed .well-known response for integrations widget");
                                return _context3.abrupt('return', null);

                            case 24:

                                // All discovered managers are per-user managers
                                manager = new _IntegrationManagerInstance.IntegrationManagerInstance(_IntegrationManagerInstance.KIND_ACCOUNT, widget["data"]["api_url"], widget["url"]);

                                console.log("Got an integration manager (untested)");

                                // We don't test the manager because the caller may need to do extra
                                // checks or similar with it. For instance, they may need to deal with
                                // terms of service or want to call something particular.

                                return _context3.abrupt('return', manager);

                            case 27:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[3, 12]]);
            }));

            function tryDiscoverManager(_x5) {
                return _ref3.apply(this, arguments);
            }

            return tryDiscoverManager;
        }()
    }]);
    return IntegrationManagers;
}();

// For debugging


global.mxIntegrationManagers = IntegrationManagers;
//# sourceMappingURL=IntegrationManagers.js.map